import * as RFSActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'refNo', order: 'descending' },
  totalRecord: 0,
  totalPage: 0,
  appliedFilterStatus: '',
  rfswoAssignedModeOrWOType: ''
};

const RFSProfile = {
  RFSID: 0,
  project: null,
  lot: null,
  requestType: null,
  workOrders: []
};

const ManageRFS = {
  items: [],
  params: defaultParams
};

const RFSState = {
  RFSProfile: RFSProfile,
  ManageRFS: ManageRFS,
  Loading: {
    loading: false,
    refNo: null
  },
  SelectListRegions: [],
  SelectListMarkets: [],
  SelectListProjects: [],
  SelectListRequestType: [],
  SelectListLots: [],
  RFSHistory: [],
  ScheduleRequestCreated: null,
  EOCProfile: {},
  RFSEndpoint: {},
  HomeownerPrimaryEmail: '',
  CreatedByList:[],
  filterWOs:[],
  updatedValueForFilterWO:[],
  updatedWOs:[],
  filterPreviewWO:[],
  RFSDefaultConfigApplied: {},
  averageAge: 0
};

export default function RFSStore(state = RFSState, action) {
  switch (action.type) {
    case RFSActionType.SEARCH_RFS_SUCCESS:
      return processSearchSuccess(state, action);
    case RFSActionType.GET_BY_RFS_ID_SUCCESS:
      return processGetByRFSIDSuccess(state, action);
    case RFSActionType.ADD_RFS:
      return {
        ...state,
        Loading: { ...state.Loading, loading: true }
      };
    case RFSActionType.ADD_RFS_SUCCESS:
      return {
        ...state,
        RFSProfile: action.data.data,
        Loading: {
          ...state.Loading,
          loading: false,
          refNo: action.data.data.refNo
        }
      };
    case RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_SUCCESS:
      return {
        ...state,
        RFSProfile: {
          ...state.RFSProfile,
          workOrders: action.data
        }
      };
    case RFSActionType.REPORT_SELECT_LIST_REGION_SUCCESS:
      return {
        ...state,
        SelectListRegions: action.data
      };
    case RFSActionType.REPORT_SELECT_LIST_MARKET_SUCCESS:
      return {
        ...state,
        SelectListMarkets: action.data
      };
    case RFSActionType.REPORT_SELECT_LIST_PROJECT_SUCCESS:
      return {
        ...state,
        SelectListProjects: action.data
      };
    case RFSActionType.REPORT_SELECT_LIST_REQUEST_TYPE_SUCCESS:
      return {
        ...state,
        SelectListRequestType: action.data
      };
    case RFSActionType.REPORT_SELECT_LIST_LOT_SUCCESS:
      return {
        ...state,
        SelectListLots: action.data
      };
    case RFSActionType.GET_RFS_HISTORY_SUCCESS:
      return {
        ...state,
        RFSHistory: action.data
      };
    case RFSActionType.RESET_RFS:
      return {
        ...state,
        ManageRFS: ManageRFS
      };
    case RFSActionType.RESET_RFS_INFO:
      return {
        ...state,
        RFSProfile: RFSProfile
      };
    case RFSActionType.ADD_SCHEDULE_RFS_SUCCESS:
      return {
        ...state,
        ScheduleRequestCreated: action.data.data,
        RFSProfile: action.data.data
      };

    case RFSActionType.GET_EOC_DETAIL_SUCCESS:
      return {
        ...state,
        EOCProfile: action.data
      };
    case RFSActionType.GET_EPL_DETAIL_SUCCESS:
      return {
        ...state,
        EPLProfile: action.data
      };

    case RFSActionType.GET_GLOBAL_ENDPOINT_RFS_SUCCESS:
      return {
        ...state,
        RFSEndpoint: action.data
      };
    case RFSActionType.EOC_TEMPLATE_HOMEOWNER_SUCCESS:
      return {
        ...state,
        EOCProfile: action.data
      };
    case RFSActionType.GET_EMAIL_PRIMARY_HOMEOWNER_SUCCESS:
      return {
        ...state,
        HomeownerPrimaryEmail: action.data
      };
      case RFSActionType.FETCH_CREATED_BY_RFS_SUCCESS:
        return {
          ...state,
          CreatedByList: action.data
        };
        case RFSActionType.FILTER_WO_SUCCESS:
          return{
            ...state,
            filterWOs : action.data
          };
          case RFSActionType.FETCH_AVERAGE_AGE_OF_RFS_SUCCESS:
          return{
            ...state,
            averageAgeOfRFS : action.data
          };
          case RFSActionType.FILTER_PREVIEW_WO_SUCCESS:
            return{
              ...state,
              filterPreviewWO : action.data
          };
        case RFSActionType.UPDATED_FILTER_VALUE_FOR_WO_SUCCESS:
          return{
            ...state,
            updatedValueForFilterWO: action.data
          };
          case RFSActionType.UPDATE_WO_RASSIGN_VALUE_SUCCESS:
            return{
              ...state,
              updatedWOs: action.data
            };
          case RFSActionType.GET_RFS_REVIEW_DATE_SUCCESS:
            return{
              ...state,
            rfsReviewDate : action.data
            };    
          
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var mRFS = {
    items: result.data.items,
    params: {
      ...state.ManageRFS.params,
      skip: result.params.Skip + 1,
      take: result.params.Take,
      sort: { field: result.params.sortField, order: result.params.sortOrder },
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      appliedFilterStatus: result.data.appliedFilterStatus,
      rfswoAssignedModeOrWOType: result.data.rfswoAssignedModeOrWOType,
      averageAge: result.data.averageAge
    }
  };
  return {
    ...state,
    ManageRFS: mRFS,
    ErrorMsg: [],
    IsOpenFormAddEdit: false, 
    RFSDefaultConfigApplied: result.params
  };
};

const processGetByRFSIDSuccess = (state, action) => {
  // delete action.data.workOrders;
  return {
    ...state,
    RFSProfile: action.data
  };
};



// WEBPACK FOOTER //
// ./src/Request-Services/reducers.js